

















import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import { QueryPacsPageList, DeletePacsData } from "@/api/pdOutPatient/pdPacs";
import imagePacs from "./imagePacs.vue";
import ajax from "@/lib/ajax";
import util from "@/lib/util";

@Component({
  components: { imagePacs },
})
export default class extends AbpBase {
  @Prop() patient: any;
  loading: boolean = false;
  asyncLoading: boolean = false;
  tableData: any = [];
  tableTotalSize: number = 0;
  queryCondition: any = {
    PatientId: 0,
    Page: 1,
    PageSize: 10,
    InspectTimeStart: null,
    InspectTimeEnd: null,
    ExamName: "病理检查",
  };
  date: any = [];
  columns = [
    {
      key: "inspectTime",
      title: "检查时间",
      width: 180,
      render: (h: any, p: any) => {
        return h("span", {}, this.formatDate(p.row.inspectTime));
      },
    },
    {
      key: "examName",
      title: "检查项目",
      width: 180,
    },
    {
      key: "examPart",
      title: "检查部位",
      width: 180,
    },
    {
      key: "examResult",
      title: "检查结果",
      minWidth: 200,
    },
    {
      key: "examDesc",
      title: "检查结果描述",
      minWidth: 200,
    },
    {
      title: "操作",
      width: 220,
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        if (p.row.isManual) {
          return h("div", [
            h(
              p.row.imageUrl ? "Button" : "",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginLeft: "15px",
                },
                on: {
                  click: () => {
                    this.showImage(p.row);
                  },
                },
              },
              "报告"
            ),
            h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: "primary",
                  },
                  on: {
                    click: () => {
                      this.toPacsData(p.row);
                    },
                  },
                },
                "查阅报告"
              ),
            ]),
          ]);
        } else {
          return h("div", [
            h(
              "Button",
              {
                props: {
                  size: "small",
                  type: "primary",
                },
                on: {
                  click: () => {
                    this.toPacsData(p.row);
                  },
                },
              },
              "查阅报告"
            ),
          ]);
        }
      },
    },
  ];

  // 病理检查记录默认查询类别
  get PathologyExamNameDefault() {
    return util.abp.setting.get("PathologyExamNameDefault");
  }

  @Watch("patient", { immediate: true, deep: true })
  handlePatientChanged() {
    this.queryCondition.PatientId = this.patient.pD_Patient_ID;
    this.getData();
  }

  pageChange(val: any) {
    this.queryCondition.Page = val;
    this.getData();
  }
  async asyncInfo() {
    this.asyncLoading = true;
    let StartDate = this.formatDate(this.date[0]);
    let EndDate = this.formatDate(this.date[1]);

    let url = `${SYNC_PACS_URL}?patientId=${this.patient.id}&patientCard=${this.patient.medicalCardNo}&fromDate=${StartDate}&toDate=${EndDate}`;
    this.$Loading.start();
    ajax
      .get(url, { timeout: 60000 })
      .then((res: any) => {
        this.$Loading.finish();
        if (res.data.code === 2000) {
          this.getData();
          this.asyncLoading = false;
        } else {
          this.$Modal.error(res.message);
          this.asyncLoading = false;
        }
      })
      .catch((err) => {
        this.$Loading.error();
        this.$Modal.error({ title: "提示", content: "读取患者数据失败：" });
      });
  }
  async getData() {
    this.loading = true;
    this.queryCondition.ExamName = this.PathologyExamNameDefault;
    let res = await QueryPacsPageList(this.queryCondition);
    this.loading = false;
    this.tableData = res.items;
    this.tableTotalSize = res.totalCount;
  }
  addPacsShow = false;
  pacsData: any = {};
  addPacsData() {
    this.pacsData = {
      saveType: "新增",
      reportTime: new Date(),
      patientId: this.patient.pD_Patient_ID,
    };
    this.addPacsShow = true;
  }
  toPacsData(pacsData: any) {
    window.open(pacsData.imageUrl);
  }
  editPacsData(pacsData: any) {
    this.pacsData = pacsData;
    this.pacsData.saveType = "编辑";
    this.addPacsShow = true;
  }
  delPacs(pacsData: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "此操作将永久删除该记录, 是否继续?",
      onOk: async () => {
        let res = await DeletePacsData({ Id: pacsData.id });
        this.getData();
      },
    });
  }
  showImagePacs = false;
  imagePacs = {};
  showImage(pacsData: any) {
    this.imagePacs = pacsData;
    this.showImagePacs = true;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pathologyManage/parts/pathologicdiagnosis2/index.vue